import React, {useEffect, useState} from "react"
import Typography from "@mui/material/Typography"
import {UxCTA as CTA} from "@next/ux-cta"
import Modal from "../Modal"
import connect from "./connect"
import {SaleBagWarning} from "../../models/text"
import {ModalContainer, ButtonContainer, CTAContainer} from "./components"

type SaleBagWarningModalProps = {
    text: SaleBagWarning
    remainOnMainSiteAction: () => void
    vipSitePath: string
    openModal: boolean
}
export const SaleBagWarningModal = ({
    text: {title, textOne, textTwo, primaryButtonText, secondaryButtonText},
    remainOnMainSiteAction,
    openModal = false,
    vipSitePath,
}: SaleBagWarningModalProps) => {
    const [isOpen, setOpenModal] = useState(false)

    const remainOnMainSiteLogic = () => {
        remainOnMainSiteAction()
        setOpenModal(false)
    }

    const goToVipSite = () => {
        window.location.href = vipSitePath
    }

    useEffect(() => {
        setOpenModal(openModal)
    }, [])
    return (
        <Modal open={isOpen} handleClose={remainOnMainSiteLogic} hideBackdrop={false}>
            <ModalContainer>
                <Typography variant="h3">{title}</Typography>
                <p>{textOne}</p>
                <p>{textTwo}</p>
                <ButtonContainer>
                    <CTAContainer>
                        <CTA
                            testId="header_SaleBagWarningModal_goToVipButton"
                            onClick={goToVipSite}
                            color="secondary"
                            state="enabled"
                            variant="contained"
                            size="medium"
                            text={primaryButtonText}
                        />
                    </CTAContainer>
                    <CTAContainer>
                        <CTA
                            testId="header_SaleBagWarningModal_stayMainSiteButton"
                            onClick={remainOnMainSiteLogic}
                            color="primary"
                            state="enabled"
                            variant="contained"
                            size="medium"
                            text={secondaryButtonText}
                        />
                    </CTAContainer>
                </ButtonContainer>
            </ModalContainer>
        </Modal>
    )
}

export default connect(SaleBagWarningModal)
